import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Puedo consultar por un familiar?',
    answer: 'Sí. Muchas personas nos contactan para recibir orientación sobre la situación de un ser querido.'
  }, {
    question: '¿La conversación es confidencial?',
    answer: 'Sí. Puedes escribir o llamar con tranquilidad para recibir orientación inicial.'
  }, {
    question: '¿Atienden casos relacionados con drogas y alcohol?',
    answer: 'Sí. Evolución Chile acompaña procesos relacionados con dependencia a drogas y alcohol.'
  }, {
    question: '¿Cuentan con distintas sedes?',
    answer: 'Sí. Contamos con sedes en entornos tranquilos y naturales, pensadas para favorecer el acompañamiento terapéutico.'
  }, {
    question: '¿Trabajan con Fonasa o Isapres?',
    answer: 'La institución trabaja junto a Fonasa e Isapres. Las condiciones pueden variar según cada caso, por eso recomendamos consultar directamente por WhatsApp.'
  }, {
    question: '¿Puedo contactar sin llenar formulario?',
    answer: 'Sí. Esta página está pensada para contacto directo por WhatsApp o llamada telefónica.'
  }, {
    question: '¿Qué pasa después de escribir por WhatsApp?',
    answer: 'Te pedirán información inicial para orientarte y ayudarte a entender los próximos pasos.'
  }, {
    question: '¿El proceso es igual para todas las personas?',
    answer: 'No. Cada caso es distinto, por eso la orientación inicial permite comprender mejor la situación antes de avanzar.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-graySoft" data-id="element-70">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="text-center mb-12" data-id="element-72">
          <h2 className="text-3xl font-bold text-azul" data-id="element-73">Preguntas Frecuentes</h2>
        </div>

        <div className="space-y-4" data-id="element-74">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden transition-all duration-200" data-id="element-75">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFAQ(index)} data-id="element-76">
                <span className="font-semibold text-gray-900 pr-4" data-id="element-77">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-78" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-79">
                <p className="text-gray-600" data-id="element-80">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}